import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { notificationsImages } from '../../../../../common/utils/productCreationUtil'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../../../../AddEditProductFormComponents/FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { CarouselWithModal } from '../../../../../common/components/CarouselWithModal/CarouselWithModal'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_METERING_NOTIFICATIONS
        }
        question="What does metering sent notify me about?"
      />
    ),
    answer: (
      <div>
        When you send a metering record to a buyer, you will receive an email
        notification regarding it.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_METERING_NOTIFICATIONS
        }
        question="What does metering accepted notify me about?"
      />
    ),
    answer: (
      <div>
        When a metering record sent by you to a buyer is accepted, you will
        receive an email notification regarding it.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_METERING_NOTIFICATIONS
        }
        question="What does metering rejected notify me about?"
      />
    ),
    answer: (
      <div>
        When a metering record sent by you to a buyer is rejected, you will
        receive an email notification regarding it.
      </div>
    ),
  },
]

interface MeteringNotificationFaqsProps {
  indexModal: number
  setIndexModal: (index: number) => void
}

export const MeteringNotificationFaqs: React.FC<
  MeteringNotificationFaqsProps
> = ({ indexModal, setIndexModal }) => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - Metering Notifications"
    faqItems={faqItems}
    customContent={
      <CarouselWithModal
        carouselData={notificationsImages}
        setCurrentIndex={setIndexModal}
        currentIndex={indexModal}
      />
    }
  />
)
